import React from 'react'

const Subscribe = () => {
    return (
        <>
            <section id="subscribe-six" className="subscribe-six-main-block">
                <div className="container">
                    <div className="subscribe-six-block">
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3 col-md-10 offset-md-1">
                                <div className="subscribe-six-mail-icon">
                                    <i className="flaticon-letter" />
                                </div>
                                <h4 className="subscribe-six-title">
                                    Subscribe your <br /> Email for Newsletter
                                </h4>
                                <form className="subscribe-six-form">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="floatingInput"
                                            placeholder="name@example.com"
                                        />
                                        <label htmlFor="floatingInput">Email Address</label>
                                    </div>
                                    <button type="button" className="btn btn-primary-six">
                                        <i className="flaticon-message" /> Subscribe
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Subscribe
